import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=3d719712&scoped=true"
import script from "./Otros.vue?vue&type=script&lang=js"
export * from "./Otros.vue?vue&type=script&lang=js"
import style0 from "./Otros.vue?vue&type=style&index=0&id=3d719712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d719712",
  null
  
)

export default component.exports